module.exports = __webpack_public_path__ + "static/media/platinum-partner5.b6cd9577.png";